import { css } from "aphrodite";
import styles from "./styles";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AnimatedButton } from "../AnimatedButton";
import { AccessibleLink } from "../AccessibleLink";

const SelectBranchComponent = ({
    branches,
    webView = true,
    selectedBranchId,
    onBranchSelect = (id, name, organisationId) => {},
}) => {
    const [t] = useTranslation(["translation"]);
    const { i18n } = useTranslation(["translation"]);

    if (!branches || branches.length === 0 || !branches[0]?.id) {
        return (
            <div className={css(styles.centerEmptyContainer)}>
                <Typography variant="h6" component="p">
                    {t("No available branches have been found. Please try again later.")}
                </Typography>
            </div>
        );
    }

    return (
        <>
            <div className={css(styles.branchList)}>
                {branches.map((branch, index) => {
                    const branchName =
                        branch["name_" + i18n.language] || branch?.name;
                    const branchAddress =
                        branch["address_" + i18n.language] || branch?.address;
                    const isSelected = branch.id === selectedBranchId;
                    const selectAriaLabel = `${t("selectBranch")}${branchName}`;

                    return (
                        <div className={css(styles.row)} key={index}>
                            {webView ? (
                                <AnimatedButton
                                    isSelected={isSelected}
                                    text={t("Select")}
                                    ariaLabel={selectAriaLabel}
                                    onClick={() => {
                                        onBranchSelect(
                                            branch.id,
                                            branch.name,
                                            branch.organisationId
                                        );
                                    }}
                                />
                            ) : (
                                <Button
                                    disableElevation
                                    disableRipple
                                    variant="contained"
                                    color={isSelected ? "secondary" : "primary"}
                                    className={css(styles.button)}
                                    aria-label={selectAriaLabel}
                                    aria-pressed={isSelected}
                                    onClick={() => {
                                        onBranchSelect(
                                            branch.id,
                                            branch.name,
                                            branch.organisationId
                                        );
                                    }}
                                >
                                    <Typography variant="h6" component="span" color="white">
                                        {t("Select")}
                                    </Typography>
                                </Button>
                            )}
                            <div className={css(styles.branchInfoColumn)}>
                                <Typography variant="h6" component="p">{branchName}</Typography>
                                <div className={css(styles.branchDetails)}>
                                    <AccessibleLink
                                        href={`https://www.google.com/maps/?q=${branch?.latitude},${branch?.longitude}`}
                                        kind="map"
                                        underline="hover"
                                        variant="body1"
                                    >
                                        {branchAddress}
                                    </AccessibleLink>
                                    {branch?.phoneNumber && (
                                        <>
                                            <span className={css(styles.separator)}>
                                                ,&nbsp;
                                            </span>
                                            <AccessibleLink
                                                href={`tel:${branch?.phoneNumber.replace(/[\s\-()]/g, "")}`}
                                                kind="tel"
                                                underline="hover"
                                                variant="body1"
                                            >
                                                {branch?.phoneNumber}
                                            </AccessibleLink>
                                        </>
                                    )}
                                    {branch?.email && (
                                        <>
                                            <span className={css(styles.separator)}>
                                                ,&nbsp;
                                            </span>
                                            <AccessibleLink
                                                href={`mailto:${branch?.email}`}
                                                kind="mailto"
                                                underline="hover"
                                                variant="body1"
                                            >
                                                {branch?.email}
                                            </AccessibleLink>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default SelectBranchComponent;
